class DZModelWikiType {

    /**
     * 主键
     */
    id = "";

    /**
     * 分类名称
     */
    name = "";

    /**
     * 标签
     */
    label = "";
}
export default DZModelWikiType;
